/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Params {
  conSiteId?: string;
}

export function apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain.PATH, 'get');
  if (params) {
    rb.query('conSiteId', params.conSiteId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConstructionDayReport>>;
    })
  );
}

apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain.PATH = '/api/v0/constructiondayreport/getConstructionDayReportsForConstructionSite';
